import { Box } from '@mui/material';
import React from 'react';

import { ChangePassword } from '../../components/change-password';
export const ChangePasswordTab: React.FC = () => {
    return (
        <Box>
            <ChangePassword />
        </Box>
    );
};
